import React from 'react'
import { Container } from 'components/Layout'
import { INumberCreateFormData, PhoneSystemNumberCreateForm } from '../PhoneSystemNumberCreateForm'

import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'

export interface IPhoneSystemNumberCreateFormModalProps extends INumberCreateFormData {
  modalCancel: () => undefined
  modalConfirm: () => undefined
}

export const PhoneSystemNumberCreateFormModal = (props: IPhoneSystemNumberCreateFormModalProps) => {
  const { modalConfirm, phoneSystemId, number, customerReference, flowId } = props
  return (
    <Container paddingTop paddingBottom className="sm">
      <div style={{ margin: '0 30px' }}>
        <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Add DID Number</div>

        <PhoneSystemNumberCreateForm
          onAfterSubmit={modalConfirm}
          initialValues={{
            phoneSystemId,
            number,
            customerReference,
            flowId,
          }}
        />
      </div>
    </Container>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberCreateFormModal/PhoneSystemNumberCreateFormModal.tsx